import {
  Component, Hammer, Droplet,
  Link as LinkIcon, ShoppingCart, Layers, Scissors,
} from 'lucide-react';

export const LIBRARY_TABS = [
  { id: 'raw_material', label: 'Raw Material', icon: Component, color: 'amber', dot: '#F59E0B', border: '#F59E0B', active_text: 'text-amber-300' },
  { id: 'fabrication', label: 'Fabrication', icon: Hammer, color: 'sky', dot: '#38BDF8', border: '#38BDF8', active_text: 'text-sky-300' },
  { id: 'surface_treatment', label: 'Surface', icon: Droplet, color: 'violet', dot: '#A78BFA', border: '#A78BFA', active_text: 'text-violet-300' },
  { id: 'fasteners', label: 'Fasteners', icon: LinkIcon, color: 'yellow', dot: '#FBBF24', border: '#FBBF24', active_text: 'text-yellow-300' },
  { id: 'purchase_parts', label: 'Purchase', icon: ShoppingCart, color: 'emerald', dot: '#34D399', border: '#34D399', active_text: 'text-emerald-300' },
  { id: 'product_builder', label: 'Product', icon: Layers, color: 'cyan', dot: '#22D3EE', border: '#22D3EE', active_text: 'text-cyan-300' },
  { id: 'remnant', label: 'Remnant', icon: Scissors, color: 'rose', dot: '#FB7185', border: '#FB7185', active_text: 'text-rose-300' },
];

export default function ProductBuilderFooter({ activeTab, onTabChange, statusLeft, statusRight }) {
  return (
    <div
      className="flex items-center px-3 bg-slate-900 border-t border-slate-700/50 text-[10px] text-slate-500 shrink-0"
      style={{ height: 32 }}
      data-testid="product-builder-footer"
    >
      {/* LEFT — status */}
      <div className="flex-1 flex items-center min-w-0 truncate">
        {statusLeft}
      </div>

      {/* CENTER — library tabs */}
      <div className="flex items-center h-full gap-px" data-testid="library-tabs">
        {LIBRARY_TABS.map(tab => {
          const isActive = activeTab === tab.id;
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              data-testid={`tab-${tab.id}`}
              className={`h-full px-2.5 flex items-center gap-1.5 transition-all duration-150 cursor-pointer select-none border-t-2 ${
                isActive
                  ? `${tab.active_text} border-current`
                  : 'text-slate-500 border-transparent hover:text-slate-300 hover:bg-slate-800/50'
              }`}
              style={isActive ? { borderTopColor: tab.border } : undefined}
              title={tab.label}
            >
              {/* Colored dot */}
              <span
                className="rounded-full shrink-0 transition-opacity duration-150"
                style={{
                  width: 5, height: 5,
                  backgroundColor: tab.dot,
                  opacity: isActive ? 1 : 0.35,
                }}
              />
              {/* Label — show on wider screens, hide smallest */}
              <span className="font-medium whitespace-nowrap hidden lg:inline" style={{ fontSize: 10 }}>
                {tab.label}
              </span>
              {/* Icon fallback on small screens */}
              <Icon className="w-3 h-3 lg:hidden" />
            </button>
          );
        })}
      </div>

      {/* RIGHT — depth / autosave */}
      <div className="flex-1 flex justify-end items-center min-w-0 truncate">
        {statusRight}
      </div>
    </div>
  );
}
